const getClassroomName = ({ name, id }) => name || `Unnamed class ${id}`;

export default getClassroomName;
